const config = {
	api: {
		idm: {
			baseUrl: 'https://idm-stage.ax-semantics.com/v1/'
		},
		quest: {
			baseUrl: 'https://quest-api-stage.ax-semantics.com/'
		}
	},
	auth: {
		clientID: 'AJqKziTZloFiAkexBwkX5AqXUnr35Gbu',
		domain: 'ax-semantics-stage.eu.auth0.com'
	},
	cockpit: {
		baseUrl: 'https://cockpit-stage.ax-semantics.com/',
	},
	translate: {
		baseUrl: 'https://translate-stage.ax-semantics.com/',
	},
}

export default config
